import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaReferenceNode } from './TypedNode'
import { SchemaReferenceModel } from './ViewModel'

export const SchemaReferencePlugin = createSchemaPlugin(
  'Schema.Reference',
  SchemaReferenceModel,
  SchemaReferenceNode
)
